import { createUserManager } from 'redux-oidc';
import { WebStorageStateStore } from 'oidc-client';
const apiUrls = require('constants/apiUrls');
import localForage from 'localforage';
import { List, Map } from 'immutable';

const store = localForage.createInstance({ name: "user_store" });

const userManagerConfig = {
  client_id: apiUrls.UI_CLIENT_ID,
  redirect_uri: apiUrls.AUTH_REDIRECT_URI,
  response_type: "id_token token",
  scope: "openid profile params email groups tech account messaging equipment order",
  authority: "https://" + apiUrls.ONE_LOGIN + "/oidc/2",
  silent_redirect_uri: apiUrls.SILENT_RENEW_REDIRECT.replace("index", ""),
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  includeIdTokenInSilentRenew: false,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: store }),
  extraQueryParams: {
    resource: 'https://svc.wowinc.com'
  }
};

const userManager = createUserManager(userManagerConfig);

export default userManager;

const techIdKey = 'tech_id';

export const getOidc = (state) => state.get('oidc');
export const getUser = (oidc) => oidc && oidc.get('user');
export const isLoadingUser = (oidc) => oidc && oidc.get('isLoadingUser');
export const getExpiresAt = (user) => user && user.get('expires_at');
export const getAccessToken = (user) => user && user.get('access_token');
export const getIdToken = (user) => user && user.get('id_token');
export const getTechId = (user) => {
  if (!user) {
    return null;
  }

  const params = user.getIn(['profile', 'params']);
  if (!params) {
    return null;
  }

  if (List.isList(params) || Array.isArray(params)) {
    return params.find(item => item.get(techIdKey));
  }

  // fallback if params ever is a plain object
  return Map.isMap(params) ? params.get(techIdKey) : params[techIdKey];
};
export const getAccessTokenFromState = (state) => getAccessTokenFromOidc(getOidc(state));
export const getAccessTokenFromOidc = (oidc) => getAccessToken(getUser(oidc));

/**
 *
 * @param {object} params params property from OneLogin response
 * @param {string} key property name to look for in params object
 */
export const findInParams = (params, key) => {
  if (!params) { return undefined; }

  // at the moment onelogin returns the 'params` property as an array of objects
  if (Array.isArray(params)) {
    const param = params.find(p => p[key]);
    return param && param[key];
  }

  // if the above ever changes for some reason, access the property directly
  return params[key];
};




/**
Full structure of OneLogin response upon auth
{
    "access_token": "...",
    "id_token": "...",
    "token_type": "Bearer",
    "profile": {
        "sub": "68312896",
        "email": "user.name@wowinc.com",
        "preferred_username": "uname",
        "name": "User Name",
        "updated_at": 1613784706,
        "given_name": "User",
        "family_name": "Name",
        "params": [
            {
                "auxiliary_market": "61",
                "aux_tech_id": "22088",
                "primary_market": "12",
                "manager_tech_id": "16546",
                "icoms_user_id": "WOW27266",
                "is_field_admin": "true",
                "tech_id": "22088"
            },
            {
                "auxiliary_market": "61",
                "tech_id": "22088",
                "primary_market": "12",
                "manager_tech_id": "16546",
                "is_field_admin": "true",
                "icoms_user_id": "WOW27266",
                "aux_tech_id": "22088"
            }
        ],
        "groups": [
            "...",
            "..."
        ],
        "sid": "9b9abf84-a46a-4ccc-b493-ae6f0a685e74",
        "s_hash": "iupynwgc2gGd7-dhD0Jw_g"
    },
    "expires_at": 1614016835
}
*/


// WEBPACK FOOTER //
// ./src/utils/userManager.js